<ng-template #timeoutTemplate let-c="close" let-d="dismiss">
    <div class="modal-header mb-0 pb-0">
      <h2 class="mb-4"><b>{{resources.title}}</b></h2>
    </div>
    <div class="modal-body mt-0 pt-0 mb-0 pb-0">
      <p>{{idleMessage}}</p>
      <p>{{resources.idleInstruction}}</p>
    </div>
    <div class="modal-footer mt-0 pt-0">
      <button type="button" class="btn btn-secondary" id="logoutButtonLabel"
        (click)="logout()">{{resources.logout}}</button>
      <button type="button" ngbAutofocus class="btn btn-primary ml-3" id="continueButtonLabel"
         (click)="extendSession()">{{resources.continue}}</button>
    </div>
  </ng-template>
  